import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RouteAction } from '@core/action/action';
import { TipoEntidadeEnum } from '@core/models/entidade';
import { NomePaginaEnum } from '@core/models/nome-pagina.enum';
import { CargoReferenciaService } from '@core/services/cargoreferencia.service';
import { EntidadesService } from '@core/services/entidades.service';
import { GrupoEconomicoService } from '@core/services/grupoeconomico.service';
import { PessoaService } from '@core/services/pessoa.service';
import { RepresentacaoService } from '@core/services/representacao.service';
import { StatusEntidadeService } from '@core/services/status.entidade.service';
import { TipoComissaoService } from '@core/services/tipocomissao.service';
import { TipoOrgaoService } from '@core/services/tipoorgao.service';
import { TipoRelacaoService } from '@core/services/tiporelacao.service';
import { EntidadeSharedDataService } from '@modules/entidade/entidade-shared-data.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { forkJoin } from 'rxjs';
import { GrupoAtualizacaoService } from '@core/services/grupo-atualizacao.service';
import { ActivatedRoute } from '@angular/router';
import { TipoReguladoraService } from '@core/services/tiporeguladora';
import { TipoEntidadeService } from '@core/services/tipoentidade.service';
import { addFormControls, dataComDigitacao } from '@shared/util/util';
import { CustomValidators } from '@core/custom-validators/validators';
import { SegmentacaoService } from '@core/services/SegmentacaoService';
import { VinculoService } from '@core/services/vinculo.service';
import { ValidaCpfCnpjService } from '@core/services/validacpfcnpj.service';
import { MessageService } from '@core/services/message.service';
import { AuthenticationService } from '@core/auth/authentication.service';
import { TipoAssociacaoService } from '@core/services/TipoAssociacaoService';
import { DominiosService } from '@core/services/dominios.service';
import { DialogService } from '@core/services/dialog.service';

@Component({
  selector: 'app-dados-basicos-form',
  templateUrl: './dados-basicos-form.component.html',
  // template: 'teste',
  styleUrl: './dados-basicos-form.component.scss'
})
export class DadosBasicosFormComponent implements OnInit, OnChanges {

  @ViewChild('formElement') formElement!: ElementRef;
  @Input() entidadeForm!: FormGroup;
  @Input() entidade!: any;
  @Input() somenteVisualizar!: any;
  @Input() nomePagina: NomePaginaEnum = NomePaginaEnum.ENTIDADE;

  tipoEntidadeList: any[] = [];
  grupoEconomicoList: any[] = [];
  tipoRelacaoList: any[] = [];
  tipoReguladoraList: any[] = [];
  situacaoList: any[] = [];
  representacaoList: any[] = [];
  cargoReferenciaList: any[] = [];
  tipoComissaoList: any[] = [];
  entidadeSuperiorList: any;
  entidadeAdministradoraList: any[] = [];
  private entidadesAreaList: any[] = [];
  pessoaAdministradoraList: any[] = [];
  grupoAtualizacaoList: any[] = [];
  segmentacaoList: any[] = [];
  aprovadorPessoasParticipantesList: any[] = [];
  entidadeAfinsList: any[] = [];
  entidadesPertenceList: any[] = [];
  entidadeAfins: any[] = [];
  perfisAprovador: any[] = [];
  tipoAssociadaList: any[] = [];
  subTipoList: any[] = [];
  pesquisaInicialRealizada: boolean = false;

  acao!: RouteAction;
  acaoEnum = RouteAction;
  inserir!: boolean;
  editar!: boolean;
  visualizar!: boolean;
  actionActual!: RouteAction;

  searchControl = new FormControl();
  esconderCnpj: boolean = false;
  cnpjObrigatorio: boolean = false;
  mostrarOrgaoFields: boolean = false;
  mostrarAreaFields: boolean = false;
  mostrarRepresentacao: boolean = false;
  mostrarRepresentacaoNacional: boolean = false;
  mostrarSegmentacao: boolean = false;
  mostrarGrupoAtualiacao: boolean = false;
  mostrarEntidadesAfins: boolean = false;
  tipoEntidadeEnum = TipoEntidadeEnum;
  tipoAssociacaoObrigatorio: boolean = this.mostrarRepresentacaoNacional;
  mostrarErroTipoAssociacao: boolean = false;

  @Input() cnpjValido: any;

  incluirInativos: boolean = false;
  dataSetHierarquia: any[] = [];
  dataSetHierarquiaPopulado: boolean = false;
  dataSetHierarquiaEditado: boolean = false;

  constructor(
    private fb: FormBuilder,
    private entidadesService: EntidadesService,
    private grupoEconomicoService: GrupoEconomicoService,
    private tipoEntidadeService: TipoEntidadeService,
    private tipoRelacaoService: TipoRelacaoService,
    private entidadeStatusService: StatusEntidadeService,
    private tipoReguladoraService: TipoReguladoraService,
    private tipoOrgaoService: TipoOrgaoService,
    private cargoReferenciaService: CargoReferenciaService,
    private representacaoService: RepresentacaoService,
    private tipoComissaoService: TipoComissaoService,
    private pesssoaService: PessoaService,
    private entidadeSharedDataService: EntidadeSharedDataService,
    private modalService: NzModalService,
    private validaCpfCnpjService: ValidaCpfCnpjService,
    private messageService: MessageService,
    private segmentacaoService: SegmentacaoService,
    private grupoAtualizacaoService: GrupoAtualizacaoService,
    private route: ActivatedRoute,
    private vinculoService: VinculoService,
    private cdr: ChangeDetectorRef,
    private authenticationService: AuthenticationService,
    private tipoAssociacaoService: TipoAssociacaoService,
    private dominiosService: DominiosService,
    private dialogService: DialogService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.cnpjValido) {
      this.entidadeForm.get('cnpjValido')?.setValue(this.cnpjValido);
    }

    if (changes['entidade'] && this.entidade) {
      this.garantirOpcoesStub();
      this.definirSeNaoEditado('tipoEntidadeId', this.entidade.tipoEntidadeId != null ? Number(this.entidade.tipoEntidadeId) : null);
      this.definirSeNaoEditado('subTipoEntidadeId', this.entidade.subTipoEntidadeId != null ? Number(this.entidade.subTipoEntidadeId) : null);
      this.definirSeNaoEditado('statusEntidadeId', this.entidade.statusEntidadeId != null ? Number(this.entidade.statusEntidadeId) : null);
      const cargosControl = this.entidadeForm.get('entidadeCargos');
      if (!this.dataSetHierarquiaEditado && !cargosControl?.dirty
        && Array.isArray(this.entidade.entidadeCargos) && this.entidade.entidadeCargos.length > 0) {
        this.dataSetHierarquia = this.entidade.entidadeCargos;
        cargosControl?.setValue(this.dataSetHierarquia, { emitEvent: false });
        cargosControl?.markAsPristine();
        this.dataSetHierarquiaPopulado = true;
      }
      this.sincronizarEstadoCarregado();
      this.cdr.detectChanges();
    }
  }

  private definirSeNaoEditado(campo: string, valor: any): void {
    const control = this.entidadeForm?.get(campo);
    if (!control || control.dirty || valor == null || valor === '') {
      return;
    }
    control.setValue(valor, { emitEvent: false });
    control.markAsPristine();
  }

  sincronizarEstadoCarregado(): void {
    const tipoBruto = this.tipoEntidadeIdControl?.value;
    const tipoId = Number(tipoBruto?.id ?? tipoBruto);
    if (tipoId) {
      this.updateFormFields(tipoId);
      this.tipoEntidadeService.listarSubTiposEntidade(tipoId).subscribe((subTipos) => {
        this.subTipoList = subTipos;
        this.garantirOpcoesStub();
      });
    }

    const entidadeAdmId = this.entidadeAdministradoraIdControl?.value;
    if (entidadeAdmId) {
      this.vinculoService.listarPesssoaAdministradoraCombo(entidadeAdmId).subscribe((data) => {
        this.pessoaAdministradoraList = data;
      });
    }

    const tipoReguladoraId = this.tipoReguladoraIdControl?.value;
    this.mostrarSegmentacao = tipoReguladoraId == TipoReguladoraEnum.SUSEP;

    const representacaoId = this.representacaoIdControl?.value;
    if (representacaoId) {
      this.mostrarEntidadesAfinsFn();
    }
    this.mostrarRepresentacaoNacional = representacaoId === 1;
    this.tipoAssociacaoObrigatorio = this.mostrarRepresentacaoNacional;
    if (!this.tipoAssociacaoObrigatorio) {
      this.mostrarErroTipoAssociacao = false;
    }

    const tipoComissao = [
      TipoEntidadeEnum.Comissao,
      TipoEntidadeEnum.Subcomissao,
      TipoEntidadeEnum.GrupoTrabalho,
    ].includes(tipoId as TipoEntidadeEnum);
    if (tipoComissao && this.usuarioAprovadorControl?.value) {
      this.validarCamposObrigatorios(['email']);
    }

    this.cdr.detectChanges();
  }

  private garantirOpcoesStub(): void {
    if (this.entidade?.tipoEntidadeId != null && !this.tipoEntidadeList.some((item) => Number(item?.id) === Number(this.entidade.tipoEntidadeId))) {
      this.tipoEntidadeList = [
        { id: Number(this.entidade.tipoEntidadeId), nomeTipoEntidade: this.entidade.nomeTipoEntidade ?? String(this.entidade.tipoEntidadeId) },
        ...this.tipoEntidadeList,
      ];
    }
    if (this.entidade?.subTipoEntidadeId != null && !this.subTipoList.some((item) => Number(item?.id) === Number(this.entidade.subTipoEntidadeId))) {
      this.subTipoList = [
        { id: Number(this.entidade.subTipoEntidadeId), nomeSubTipoEntidade: this.entidade.nomeSubTipoEntidade ?? String(this.entidade.subTipoEntidadeId) },
        ...this.subTipoList,
      ];
    }
    if (this.entidade?.statusEntidadeId != null && !this.situacaoList.some((item) => Number(item?.id) === Number(this.entidade.statusEntidadeId))) {
      this.situacaoList = [
        { id: Number(this.entidade.statusEntidadeId), nomeStatusEntidade: this.entidade.nomeStatusEntidade ?? String(this.entidade.statusEntidadeId) },
        ...this.situacaoList,
      ];
    }
  }

  onCnpjValid() {
    let cnpj = this.cnpjControl?.value;
    if (cnpj) {
      if (cnpj?.length < 14) {
        this.messageService.error('O CNPJ deve conter 14 digitos.');
      }
      else {
        this.validaCpfCnpjService.validaCpfCnpj(cnpj).subscribe({
          next: cpfCnpjValido => {
            if (!cpfCnpjValido) {
              this.entidadeForm.get('cnpj')?.setErrors({
                cnpj: true,
                mensagem: (campo: string) => `O campo <b>${campo}</b> não é um CNPJ válido`
              });
              this.messageService.error('CNPJ inválido.');
              this.entidadeForm.get('cnpjValido')?.setValue(false);
            } else {
              this.entidadeForm.get('cnpjValido')?.setValue(true);
            }
          },
          error: () => {
            this.messageService.error('Error ao validar CNPJ.');
          }
        });
      }
    }
  }


  ngOnInit(): void {
    this.checkUrl();
    this.construirForm();
    this.carregarListas();

    this.carregaComboSubTipo();

    this.tipoEntidadeIdControl.valueChanges.subscribe((val) => {
      const id = Number(val?.id ?? val);
      if (id) {
        this.updateFormFields(id);
        this.dataSetHierarquia = [];
      }
    });

    this.subTipoControl.valueChanges.subscribe((val) => {
      this.criarDataSetHierarquico();
    });

    this.entidadeAdministradoraIdControl?.valueChanges.subscribe((val) => {
      if (val) {
        console.log('bateu entidadeAdministradoraIdControl: ');
        this.vinculoService.listarPesssoaAdministradoraCombo(val).subscribe(data => {
          this.pessoaAdministradoraList = data
          console.log('data: ', this.pessoaAdministradoraList);
        }
        );
      }
    });

    this.tipoReguladoraIdControl?.valueChanges.subscribe((val) => {
      (val == TipoReguladoraEnum.SUSEP)
        ? this.mostrarSegmentacao = true
        : this.mostrarSegmentacao = false;

      this.cdr.detectChanges();

    });

    const tipoEntidade = [
      TipoEntidadeEnum.Comissao,
      TipoEntidadeEnum.Subcomissao,
      TipoEntidadeEnum.GrupoTrabalho
    ].includes(this.tipoEntidadeIdControl?.value);

    if (tipoEntidade) {
      this.usuarioAprovadorControl?.valueChanges.subscribe((val) => {
        if (val) {
          this.validarCamposObrigatorios(['email']);
        } else {
          this.clearCamposObrigatorios(['email']);
        }
      });
    }

    this.representacaoIdControl?.valueChanges.subscribe((val) => {
      if (val) {
        this.mostrarEntidadesAfinsFn();
      }
      this.mostrarRepresentacaoNacional = val === 1;
      this.tipoAssociacaoObrigatorio = this.mostrarRepresentacaoNacional;
      if (!this.tipoAssociacaoObrigatorio) {
        this.mostrarErroTipoAssociacao = false;
      }
    });

    this.entidadeForm.get('tipoAssociacao')?.valueChanges.subscribe((val) => {
      if (val) {
        this.mostrarErroTipoAssociacao = false;
      }
    });
  }

  marcarTipoAssociacaoComoInvalido(): void {
    this.mostrarErroTipoAssociacao = true;
  }

  construirForm() {
    addFormControls(this.entidadeForm, {
      tipoEntidadeId: [],
      statusEntidadeId: [],
      flagEmpresaEstrangeira: [false],
      cnpj: [CustomValidators.cpfCnpj],
      numRegistroEmpresaEstrangeira: [],
      nomeRazaoSocial: [],
      nomeFantasia: ['', Validators.required],
      sigla: [],
      representacao: [],
      anosMandato: [false],
      // dataInicioMandato: [],
      // dataFimMandato: [undefined],
      tipoComissaoId: [undefined],
      flagEntidadeSigilosa: [false],
      flagComissaoPermanente: [false],
      entidadeAdministradoraId: [],
      pessoaAdminstradoraId: [],
      sigilosa: [false],
      permanente: [false],
      tipoComissao: [],
      pessoaAdministradoraId: [],
      tipoReguladora: [],
      grupoEconomico: [],
      entidadesAssociadas: [],
      empresaEstrangeira: [],
      numIdEmpEstrangeira: [],
      representacaoId: [],
      codigoReguladora: [],
      tipoReguladoraId: [],
      grupoEconomicoId: [],
      entidadeAfins: [],
      mandatos: [],
      emailAprovador: [],
      cnpjValido: [],
      entidadePertenceId: [],
      dataControleAtualizacao: [],
      usuarioAprovador: [],
      email: [],
      tipoAssociacao: [],
      subTipoEntidadeId: [undefined, Validators.required]
    });
  }

  carregarListas(): void {
    this.entidadesService.perfilAprovador('Aprovador').subscribe(data => {
      this.perfisAprovador = data;
    });

    forkJoin({
      grupoEconomico: this.grupoEconomicoService.listar(),
      tipoEntidade: this.tipoEntidadeService.listar(),
      tipoRelacao: this.tipoRelacaoService.listar(),
      // entidadeSuperior: this.entidadesService.entidadeSuperior(),
      tipoReguladora: this.tipoReguladoraService.tipoReguladoraList(),
      tipoSegmento: this.segmentacaoService.segmentacaoList(),
      grupoAtualizacao: this.grupoAtualizacaoService.listar(),
      entidade: this.entidadesService.entidadeCombo(),
      entidadePertence: this.entidadesService.entidadeRepresentacaoNacional(),
      entidadeAfins: this.entidadesService.entidadeAfinsCombo(),
      tipoAssociada: this.tipoAssociacaoService.list()
    }).subscribe(
      ({
        grupoEconomico,
        tipoEntidade,
        tipoRelacao,
        entidade,
        entidadeAfins,
        tipoReguladora,
        grupoAtualizacao,
        tipoSegmento,
        entidadePertence,
        tipoAssociada
      }) => {
        this.grupoEconomicoList = this.ordenarPorNome(grupoEconomico, 'nomeGrupoEconomico');
        this.tipoEntidadeList = tipoEntidade;
        this.tipoRelacaoList = tipoRelacao;
        this.segmentacaoList = tipoSegmento;
        this.entidadesAreaList = this.filtrarEntidadesArea(entidade);
        this.entidadeAdministradoraList = this.entidadesAreaList;
        this.tipoAssociadaList = tipoAssociada;
        this.tipoReguladoraList = tipoReguladora;
        this.grupoAtualizacaoList = this.ordenarPorNome(grupoAtualizacao, 'nomeGrupoAtualizacao');
        this.entidadeAfinsList = entidadeAfins;
        this.entidadesPertenceList = entidadePertence.filter((entidade: any) => entidade.representacaoId === 1)
        .sort((a: any, b: any) => a.nomeFantasia.localeCompare(b.nomeFantasia));
      }
    );

    this.entidadeStatusService.listar().subscribe(situacao => {
      this.situacaoList = situacao;

      // Se a ação for "novo", selecione o status "Ativa"
      if (this.acao == RouteAction.Inserir) {
        const statusAtiva = this.situacaoList.find((item: { nomeStatusEntidade: string; }) => item.nomeStatusEntidade === StatusNomeEnum.ATIVA);
        if (statusAtiva) {
          this.statusEntidadeIdControl?.setValue(statusAtiva.id);
        }
      }
    });
  }

  carregaComboSubTipo() {
    this.tipoEntidadeIdControl.valueChanges.subscribe((value: any) => {
      const id = value?.id ?? value;
      if (!value) {
        this.subTipoControl?.setValue(null);
        return;
      }
      if (id) {
        this.tipoEntidadeService.listarSubTiposEntidade(id).subscribe((subTipos) => {
          this.subTipoList = subTipos;
          // this.subTipoControl?.setValue(null);
        });
      } else {
        this.subTipoControl?.setValue(null);
      }
    });
  }

  updateFormFields(tipoEntidadeId: number): void {
    this.esconderCnpjFn();
    this.mostrarRepresentacaoFn();
    this.mostrarGrupoAtualiacaoFn();
    this.mostrarEntidadesAfinsFn();

    if (this.isConfederacao(tipoEntidadeId) || this.isFederacao(tipoEntidadeId) || this.isSindicato(tipoEntidadeId)) {
      this.representacaoService.listar().subscribe(representacao => this.representacaoList = representacao);
      this.onSearchEntidadeSuperior(this.searchControl.value);
    }
    else if (this.isOrgao(tipoEntidadeId)) {
      this.mostrarOrgaoFields = true;
      this.cargoReferenciaService.listar().subscribe(cargoReferencia => this.cargoReferenciaList = cargoReferencia);
      this.onSearchEntidadeSuperior(this.searchControl.value);
    } else if (this.isArea(tipoEntidadeId)) {
      this.mostrarAreaFields = true;
      this.cargoReferenciaService.listar().subscribe(cargoReferencia => this.cargoReferenciaList = cargoReferencia);
      this.onSearchEntidadeSuperior(this.searchControl.value);
    }
    else if (this.isComissao(tipoEntidadeId) || this.isSubcomissao(tipoEntidadeId) || this.isGrupoTrabalho(tipoEntidadeId)) {
      forkJoin({
        tipoComissao: this.tipoComissaoService.listar(),
        cargoReferencia: this.cargoReferenciaService.listar(),
      }).subscribe((
        {
          tipoComissao,
          cargoReferencia
        }) => {
        this.tipoComissaoList = tipoComissao;
        this.cargoReferenciaList = cargoReferencia;
      });

      this.onSearchEntidadeSuperior(this.searchControl.value);
    }
    else if (this.isSeguradora(tipoEntidadeId) || this.isSaude(tipoEntidadeId) || this.isCapitalizacao(tipoEntidadeId)) {
      forkJoin({
        grupoEconomico: this.grupoEconomicoService.listar(),
        tipoReguladora: this.tipoReguladoraService.tipoReguladoraList()
      }).subscribe((
        {
          grupoEconomico,
          tipoReguladora
        }) => {
        this.grupoEconomicoList = grupoEconomico.sort((a: { nomeGrupoEconomico: string; }, b: { nomeGrupoEconomico: any; }) => a.nomeGrupoEconomico.localeCompare(b.nomeGrupoEconomico));
        this.tipoReguladoraList = tipoReguladora;
      });

      this.onSearchEntidadeSuperior(this.searchControl.value);
    }
  }

  onSearchEntidadeSuperior(value: any) {
    this.entidadesService.getEntidadeSuperiores().subscribe(entidadesSuperiores => this.entidadeSuperiorList = entidadesSuperiores);
  }

  validarCamposObrigatorios(requiredFields: any[]): void {
    requiredFields.forEach(field => {
      const control = this.entidadeForm.get(field);
      if (control) {
        control.setValidators([Validators.required]);
        control.updateValueAndValidity();
      }
    });
  }

  clearCamposObrigatorios(requiredFields: any[]): void {
    requiredFields.forEach(field => {
      const control = this.entidadeForm.get(field);
      if (control) {
        control.clearValidators();
        control.updateValueAndValidity();
      }
    });
  }

  onRepresentacaoChange(value: any) {
    this.mostrarRepresentacaoNacional = value === 1;
    this.tipoAssociacaoObrigatorio = this.mostrarRepresentacaoNacional;
    if (!this.tipoAssociacaoObrigatorio) {
      this.mostrarErroTipoAssociacao = false;
    }
  }

  selectPessoasAdministradoras(item: any) {
    if (item) {
      console.log('item: ', item)
      this.pessoaAdminstradoraIdControl?.reset();
      this.vinculoService.listarPesssoaAdministradoraCombo(item).subscribe(data => {
        this.pessoaAdministradoraList = data
        console.log('data: ', this.pessoaAdministradoraList);
      }


      );
    }
  }

  esconderCnpjFn() {
    const tiposQueMostramCnpj = [
      TipoEntidadeEnum.Orgao,
      TipoEntidadeEnum.Area,
      TipoEntidadeEnum.Comissao,
      TipoEntidadeEnum.GrupoTrabalho,
      TipoEntidadeEnum.Subcomissao,
      TipoEntidadeEnum.Reguladora
    ];

    this.obrigatoriedadeCNPJ();
    this.esconderCnpj = tiposQueMostramCnpj.includes(this.tipoEntidadeIdControl?.value);
  }

  obrigatoriedadeCNPJ() {
    const tiposComCNPJObrigatorio = [
      TipoEntidadeEnum.Sindicato,
      TipoEntidadeEnum.Seguradora,
      // TipoEntidadeEnum.Reguladora,
      TipoEntidadeEnum.Corretora,
      TipoEntidadeEnum.Capitalizacao,
      TipoEntidadeEnum.Saude,
      TipoEntidadeEnum.Previdencia
    ];

    if (tiposComCNPJObrigatorio.includes(this.tipoEntidadeIdControl?.value)) {
      this.cnpjObrigatorio = true;
      this.validarCamposObrigatorios(['cnpj']);
    } else {
      this.cnpjObrigatorio = false;
      this.clearCamposObrigatorios(['cnpj']);
    }

    this.cnpjControl?.updateValueAndValidity();
  }

  mostrarRepresentacaoFn() {
    const tiposQueMostramRepresentacao = [
      TipoEntidadeEnum.Confederacao,
      TipoEntidadeEnum.Federacao,
      TipoEntidadeEnum.Sindicato
    ];

    this.mostrarRepresentacao = tiposQueMostramRepresentacao.includes(this.tipoEntidadeIdControl?.value);
    this.cdr.detectChanges();
  }

  loadEntidadesAdministradoras(value: string): void {
    if (!value || value.length < 3) {
      this.entidadeAdministradoraList = this.entidadesAreaList;
      return;
    }
    const termo = value.toLowerCase();
    this.entidadeAdministradoraList = this.entidadesAreaList.filter((entidade: any) =>
      (entidade.nome ?? '').toLowerCase().includes(termo) ||
      (entidade.nomeFantasia ?? '').toLowerCase().includes(termo) ||
      (entidade.nomeRazaoSocial ?? '').toLowerCase().includes(termo)
    );
  }

  private filtrarEntidadesArea(entidades: any[]): any[] {
    return (entidades ?? []).filter(
      (entidade: any) => entidade.tipoEntidadeId === TipoEntidadeEnum.Area
    );
  }

  mostrarGrupoAtualiacaoFn() {
    const tiposQueMostramGrupoAtualizacao = [
      TipoEntidadeEnum?.Seguradora,
      TipoEntidadeEnum?.Saude,
      TipoEntidadeEnum?.Capitalizacao,
      TipoEntidadeEnum?.Previdencia
    ];

    this.mostrarGrupoAtualiacao = tiposQueMostramGrupoAtualizacao.includes(this.tipoEntidadeIdControl?.value);
  }

  private ordenarPorNome(lista: any[], campo: string): any[] {
    return lista.sort((a, b) => a[campo].localeCompare(b[campo]));
  }

  private checkUrl() {
    this.route.data.subscribe((data) => {
      this.acao = data['acao'];
      this.inserir = this.acao == RouteAction.Inserir;
      this.editar = this.acao == RouteAction.Editar;
      this.visualizar = this.acao == RouteAction.Visualizar;
    });
  }

  mostrarEntidadesAfinsFn() {
    const tiposQueNaoMostramEntidadeAfim = [
      TipoEntidadeEnum?.Seguradora,
      TipoEntidadeEnum?.Previdencia,
      TipoEntidadeEnum?.Saude,
      TipoEntidadeEnum?.Capitalizacao,
      TipoEntidadeEnum?.Area,
    ];

    this.mostrarEntidadesAfins = !tiposQueNaoMostramEntidadeAfim.includes(this.tipoEntidadeIdControl?.value) && this.representacaoIdControl?.value !== 1;
  }

  criarDataSetHierarquico() {
    // Se já foi editado, manter os dados do formulário
    if (this.dataSetHierarquiaEditado) {
      let cargos = this.entidadeForm.get('entidadeCargos')?.value || [];
      // Se tiver dataSet aninhado, extrair apenas o array
      if (cargos && typeof cargos === 'object' && !Array.isArray(cargos) && cargos.dataSet) {
        cargos = cargos.dataSet;
      }
      this.dataSetHierarquia = Array.isArray(cargos) ? cargos : [];
      return;
    }

    // Se a entidade tem cargos salvos, usar esses dados
    if (this.entidade?.entidadeCargos && Array.isArray(this.entidade.entidadeCargos) && this.entidade.entidadeCargos.length > 0) {
      this.dataSetHierarquia = this.entidade.entidadeCargos;
      this.dataSetHierarquiaPopulado = true;
      this.entidadeForm.get('entidadeCargos')?.setValue(this.dataSetHierarquia);
      return;
    }

    // Se não houver dados, buscar a hierarquia padrão
    this.resetarHierarquia();
  }

  resetarHierarquia(editado?: boolean) {
    if (this.tipoEntidadeIdControl?.value && this.subTipoControl?.value) {
      this.dominiosService.consultarCargoHierarquiaEntidade(this.tipoEntidadeIdControl?.value, this.subTipoControl?.value, undefined, this.incluirInativos).subscribe((data) => {
        this.dataSetHierarquia = data;
        this.dataSetHierarquiaPopulado = false;
        this.dataSetHierarquiaEditado = editado || false;
        this.entidadeForm.get('entidadeCargos')?.setValue(data);
        // this.paginator.totalItens = data.totalElements;
      });
    }
  }

  atualizarEstrutura(param: any) {
    if (param?.incluirInativos !== undefined) {
      this.incluirInativos = param.incluirInativos;
    }
    this.editarItem(param);
  }

  salvarItem(dataSet: any) {
    if (!dataSet.length) {
      this.entidadeForm.get('entidadeCargos')?.setValue(dataSet);
      this.dataSetHierarquiaEditado = true;
      this.dataSetHierarquiaPopulado = true;
      // this.dominiosService.cadastrarHierarquia(dataSet).subscribe({
      //   next: () => {
      //     this.messageService.success(`Domínio inserido com sucesso.`);
      //   },
      //   error: (err) => {
      //     if (Array.isArray(dataSet) && dataSet.length) {
      //       const idRemover = dataSet[dataSet.length - 1]?.id;
      //       if (idRemover) {
      //         this.dataSetHierarquia = this.dataSetHierarquia.filter((x: any) => x.id !== idRemover);
      //       }
      //     }
      //   }
      // });
    } else {
      this.editarItem(dataSet);
    }
  }

  editarItem(dataSet: any) {
    // const dataSetNovo = dataSet?.dataSet || dataSet;
    // const dataSetEnvio = dataSetNovo.length ? dataSetNovo : [];
    this.entidadeForm.get('entidadeCargos')?.setValue(dataSet);
    this.dataSetHierarquiaEditado = true;
    this.dataSetHierarquiaPopulado = true;

    // this.dominiosService.editarHierarquia(dataSetEnvio).subscribe({
    //   next: () => {
    //     this.messageService.success(`Domínio atualizado com sucesso.`);
    //     this.criarDataSetHierarquico();
    //   },
    //   error: (err) => {
    //     if (Array.isArray(dataSetNovo) && dataSetNovo.length) {
    //       const idRemover = dataSetNovo[dataSetNovo.length - 1]?.id;
    //       if (idRemover) {
    //         this.dataSetHierarquia = this.dataSetHierarquia.filter((x: any) => x.id !== idRemover);
    //       }
    //     }
    //   }
    // });
  }

  removerItem(item: any) {
    const message = `Confirma a remoção do cargo: <br> <strong>${item.nomeCargoReferencia}</strong>?`;

    this.dialogService.confirm(
      message,
      () => {
        if (!this.entidade?.entidadeCargos?.length || !this.dataSetHierarquiaPopulado) {
          this.dataSetHierarquia = this.removerItemRecursivo(this.dataSetHierarquia, item.id);
          this.dataSetHierarquiaEditado = true;
          this.dataSetHierarquiaPopulado = true;
          this.entidadeForm.get('entidadeCargos')?.setValue(this.dataSetHierarquia);
          return;
        }
        else {
          this.dominiosService.inativarItemNovoCargos(this.entidade.id, item.id).subscribe({
            next: () => {
              this.messageService.success('Domínio inativado com sucesso.');
              this.dataSetHierarquiaEditado = true;
              this.dataSetHierarquiaPopulado = true;
              this.dataSetHierarquia = this.removerItemRecursivo(this.dataSetHierarquia, item.id);
              this.entidadeForm.get('entidadeCargos')?.setValue(this.dataSetHierarquia);
            },
            error: (err) => {
              console.error(err);
              this.messageService.error('Erro ao inativar domínio.');
            }
          });
        }
      }
    );

  }

  private removerItemRecursivo(lista: any[], idRemover: number): any[] {
    return lista
      .filter((item: any) => item.id !== idRemover)
      .map((item: any) => ({
        ...item,
        children: item.children ? this.removerItemRecursivo(item.children, idRemover) : []
      }));
  }

  reativarItem(item: any) {
    const message = `Confirma a reativação do domínio: <br> <strong>${item.nomeCargoReferencia}</strong>?`;

    this.dialogService.confirm(
      message,
      () => {
        if (!this.entidade?.id) {
          this.messageService.error('Não é possível reativar cargos de uma entidade que não está cadastrada.');
          return;
        }

        // Nota: Adapte o nome do método conforme a sua API
        // this.dominiosService.reativarItemNovoCargos(this.entidade.id, item.id).subscribe({
        //   next: () => {
        //     this.messageService.success('Domínio reativado com sucesso.');
        //     this.dataSetHierarquiaEditado = true;
        //     this.dataSetHierarquiaPopulado = true;
        //     // Re-carregar a hierarquia para incluir o item reativado
        //     this.resetarHierarquia(true);
        //   },
        //   error: (err: any) => {
        //     console.error(err);
        //     this.messageService.error('Erro ao reativar domínio.');
        //   }
        // });
      }
    );
  }

  removerSelecionados(ids: number[]) {
    const removerRecursivoMultiplos = (lista: any[], idsRemover: number[]): any[] => {
      return lista
        .filter((x: any) => !idsRemover.includes(x.id))
        .map((x: any) => ({
          ...x,
          children: x.children ? removerRecursivoMultiplos(x.children, idsRemover) : []
        }));
    };
    const dataSetAtualizado = removerRecursivoMultiplos(this.dataSetHierarquia, ids);

    console.log('dataSetAtualizado: ', dataSetAtualizado);
    this.dataSetHierarquia = dataSetAtualizado;
    this.entidadeForm.get('entidadeCargos')?.setValue(dataSetAtualizado);
    // this.editarItem(dataSetAtualizado);
  }

  resetHierarquia(reset: boolean) {
    reset ? this.resetarHierarquia(true) : this.dataSetHierarquia = [];
  }

  compareFn(a: any, b: any): boolean {
    if (typeof a === 'boolean' && (typeof b === 'string' || typeof b === 'boolean')) {
      b = b === 'true';
    }
    if (Array.isArray(a) && Array.isArray(b) && a.length === b.length) {
      const sortedA = a.slice().sort((x: any, y: any) => x.idEntidade - y.idEntidade);
      const sortedB = b.slice().sort((x: any, y: any) => x.idEntidade - y.idEntidade);
      return sortedA.every((itemA, index) => this.compareFn(itemA, sortedB[index]));
    }
    else if (a?.idEntidade !== undefined && b?.idEntidade !== undefined) {
      return a.idEntidade === b.idEntidade;
    }
    else if (Array.isArray(a) && a.length && typeof b === 'number') {
      return a[0]?.idEntidade === b;
    }
    return a === b;
  }

  onInputDateChange(inputValue: any, campo: string): void {
    dataComDigitacao(inputValue, this.entidadeForm, campo);
  }

  isConfederacao(tipoEntidadeId?: number): boolean {
    return tipoEntidadeId ? tipoEntidadeId === TipoEntidadeEnum.Confederacao : this.tipoEntidadeIdControl?.value === TipoEntidadeEnum.Confederacao;
  }

  isFederacao(tipoEntidadeId?: number): boolean {
    return tipoEntidadeId ? tipoEntidadeId === TipoEntidadeEnum.Federacao : this.tipoEntidadeIdControl?.value === TipoEntidadeEnum.Federacao;
  }

  isSindicato(tipoEntidadeId?: number): boolean {
    return tipoEntidadeId ? tipoEntidadeId === TipoEntidadeEnum.Sindicato : this.tipoEntidadeIdControl?.value === TipoEntidadeEnum.Sindicato;
  }

  isSeguradora(tipoEntidadeId?: number): boolean {
    return tipoEntidadeId ? tipoEntidadeId === TipoEntidadeEnum.Seguradora : this.tipoEntidadeIdControl?.value === TipoEntidadeEnum.Seguradora;
  }

  isReguladora(tipoEntidadeId?: number): boolean {
    return tipoEntidadeId ? tipoEntidadeId === TipoEntidadeEnum.Reguladora : this.tipoEntidadeIdControl?.value === TipoEntidadeEnum.Reguladora;
  }

  isCorretora(tipoEntidadeId?: number): boolean {
    return tipoEntidadeId ? tipoEntidadeId === TipoEntidadeEnum.Corretora : this.tipoEntidadeIdControl?.value === TipoEntidadeEnum.Corretora;
  }

  isCapitalizacao(tipoEntidadeId?: number): boolean {
    return tipoEntidadeId ? tipoEntidadeId === TipoEntidadeEnum.Capitalizacao : this.tipoEntidadeIdControl?.value === TipoEntidadeEnum.Capitalizacao;
  }

  isSaude(tipoEntidadeId?: number): boolean {
    return tipoEntidadeId ? tipoEntidadeId === TipoEntidadeEnum.Saude : this.tipoEntidadeIdControl?.value === TipoEntidadeEnum.Saude;
  }

  isOrgao(tipoEntidadeId?: number): boolean {
    return tipoEntidadeId ? tipoEntidadeId === TipoEntidadeEnum.Orgao : this.tipoEntidadeIdControl?.value === TipoEntidadeEnum.Orgao;
  }

  isArea(tipoEntidadeId?: number): boolean {
    return tipoEntidadeId ? tipoEntidadeId === TipoEntidadeEnum.Area : this.tipoEntidadeIdControl?.value === TipoEntidadeEnum.Area;
  }

  isComissao(tipoEntidadeId?: number): boolean {
    return tipoEntidadeId ? tipoEntidadeId === TipoEntidadeEnum.Comissao : this.tipoEntidadeIdControl?.value === TipoEntidadeEnum.Comissao;
  }

  isGrupoTrabalho(tipoEntidadeId?: number): boolean {
    return tipoEntidadeId ? tipoEntidadeId === TipoEntidadeEnum.GrupoTrabalho : this.tipoEntidadeIdControl?.value === TipoEntidadeEnum.GrupoTrabalho;
  }

  isSubcomissao(tipoEntidadeId?: number): boolean {
    return tipoEntidadeId ? tipoEntidadeId === TipoEntidadeEnum.Subcomissao : this.tipoEntidadeIdControl?.value === TipoEntidadeEnum.Subcomissao;
  }

  isPrevidencia(tipoEntidadeId?: number): boolean {
    return tipoEntidadeId ? tipoEntidadeId === TipoEntidadeEnum.Previdencia : this.tipoEntidadeIdControl?.value === TipoEntidadeEnum.Previdencia;
  }

  isOutrasEntidades(tipoEntidadeId?: number): boolean {
    return tipoEntidadeId ? tipoEntidadeId === TipoEntidadeEnum.OutrasEntidades : this.tipoEntidadeIdControl?.value === TipoEntidadeEnum.OutrasEntidades;
  }

  get tipoEntidadeIdControl() {
    return this.entidadeForm.get('tipoEntidadeId') as FormControl;
  }

  get tipoEntidadeIdValue() {
    return this.entidadeForm.get('tipoEntidadeId');
  }

  get statusEntidadeIdControl() {
    return this.entidadeForm.get('statusEntidadeId') as FormControl;
  }

  get flagEmpresaEstrangeiraControl() {
    return this.entidadeForm.get('flagEmpresaEstrangeira') as FormControl;
  }

  get anosMandatoControl() {
    return this.entidadeForm.get('anosMandato');
  }

  get cnpjControl() {
    return this.entidadeForm.get('cnpj');
  }

  get representacaoIdControl() {
    return this.entidadeForm.get('representacaoId');
  }

  get entidadeAdministradoraIdControl() {
    return this.entidadeForm.get('entidadeAdministradoraId') as FormControl;
  }

  get pessoaAdminstradoraIdControl() {
    return this.entidadeForm.get('pessoaAdminstradoraId');
  }

  get tipoReguladoraIdControl() {
    return this.entidadeForm.get('tipoReguladoraId');
  }

  get usuarioAprovadorControl() {
    return this.entidadeForm.get('usuarioAprovador');
  }

  get subTipoControl() {
    return this.entidadeForm.get('subTipoEntidadeId') as FormControl;
  }

  get subTipoValue() {
    return this.entidadeForm.get('subTipoEntidadeId');
  }
}



export enum StatusNomeEnum {
  ATIVA = 'Ativa',
  INATIVA = 'Inativa'
}

export enum TipoReguladoraEnum {
  ANS = 1,
  SUSEP = 2
}
